import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
		isActiveData:{
			isActive:1,
			isActiveShow:false
		}
		
	},
    mutations: {
		getIsActive(state,Active){
			state.isActiveData.isActive = Active
			state.isActiveData.isActiveShow = !state.isActiveData.isActiveShow
		}
	},
    actions: {}
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js